import { render, staticRenderFns } from "./BlockAreaItem.vue?vue&type=template&id=2f525380&scoped=true&"
import script from "./BlockAreaItem.vue?vue&type=script&lang=js&"
export * from "./BlockAreaItem.vue?vue&type=script&lang=js&"
import style0 from "./BlockAreaItem.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BlockAreaItem.vue?vue&type=style&index=1&id=2f525380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f525380",
  null
  
)

export default component.exports